import { userConstants } from '../actions';

const initialState = {
    model: undefined,
    perms: [],
    isLoading: false,
    previousHref: null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case userConstants.USER_LOGIN_REQUEST: {
            return {
                ...state,
                isLoading: true
            };
        }
        case userConstants.USER_LOGIN_SUCCESS: {
            return {
                ...state,
                model: action.payload,
                isLoading: false
            };
        }
        case userConstants.USER_LOGIN_FAILURE: {
            return {
                ...state,
                isLoading: false
            };
        }
        case userConstants.USER_LOGOUT_SUCCESS: {
            return initialState;
        }
        case userConstants.PERMS_UPDATED_SUCCESS: {
            return {
                ...state,
                perms: action.payload
            };
        }
        case userConstants.PREVIOUS_HREF_ADDED_SUCCESS: {
            return {
                ...state,
                previousHref: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
